import React, { createContext, useContext, ReactNode, useMemo } from 'react';

export interface IApiContext {
    superUser?: boolean;
}

export interface HelperProviderProps {
    superUser?: boolean;
    children: ReactNode;
}

const ApiContext = createContext<IApiContext>({});

export function useSuperUser() {
    return !!(useContext(ApiContext) as IApiContext)?.superUser;
}

export const ApiProvider = ({ children, superUser }: HelperProviderProps) => {
    const value = useMemo(() => ({ superUser }), [superUser]);

    return <ApiContext.Provider value={value}>{children}</ApiContext.Provider>;
};
